import React, { FC } from 'react';

import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: ['slide 1', 'slide 2', 'slide 3'],
    multi_left_button: ['never show 1', 'never show 2', 'never show 3'],
    multi_right_button: ['close 1', 'close 2', 'close 3']
  }
};

const SimpleCardModalTracking: FC = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        background: 'none'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'end',
          gap: '20px',
          paddingTop: '200px'
        }}
      >
        <div>
          <EditTracking
            value={tracking?.multi_image?.[currentIndex]}
            type="multi_image"
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginTop: '50px'
          }}
        >
          <EditTracking
            value={tracking?.multi_left_button?.[currentIndex]}
            type="multi_left_button"
          />
          <EditTracking
            value={tracking?.multi_right_button?.[currentIndex]}
            type="multi_right_button"
          />
        </div>
      </div>
    </div>
  );
};

export default SimpleCardModalTracking;
